import Svg, { Path } from 'react-native-svg';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	width?: number;
	height?: number;
	starColor?: string;
	outlineColor?: string;
	sparkleColor?: string;
}

export default ({
	width = Dimens.iconSize30,
	height = Dimens.iconSize30,
	starColor = Colors.white,
	outlineColor = Colors.green,
	sparkleColor = Colors.goldLight,
}: Props) => (
	<Svg height={height} viewBox="0 0 49.372 27.96" width={width}>
		<Path
			d="m39.453 17.229-4.748 2.496a.5.5 0 0 1-.725-.527l.906-5.288a.5.5 0 0 0-.143-.442L30.9 9.723a.5.5 0 0 1 .277-.853l5.309-.771a.5.5 0 0 0 .377-.274l2.374-4.81a.5.5 0 0 1 .896 0l2.375 4.81a.5.5 0 0 0 .376.274l5.31.771a.5.5 0 0 1 .276.853l-3.841 3.745a.5.5 0 0 0-.144.442l.907 5.288a.5.5 0 0 1-.726.527l-4.748-2.496a.5.5 0 0 0-.466 0Z"
			fill={starColor}
		/>
		<Path
			d="M38.565 2.683a1.25 1.25 0 0 1 2.242 0l2.316 4.692 5.179.753a1.25 1.25 0 0 1 1.07 1.29l-.013.127a1.25 1.25 0 0 1-.364.715l-3.749 3.653.886 5.158a1.25 1.25 0 0 1-.896 1.416l-.125.027a1.25 1.25 0 0 1-.793-.125l-4.632-2.436-4.632 2.436a1.25 1.25 0 0 1-1.618-.408l-.07-.117a1.25 1.25 0 0 1-.126-.793l.885-5.158-3.747-3.653a1.25 1.25 0 0 1-.113-1.665l.09-.102a1.25 1.25 0 0 1 .715-.365l5.178-.753 2.317-4.692ZM39.686 3.8l-2.15 4.356a1.25 1.25 0 0 1-.941.684l-4.808.698 3.48 3.392c.261.255.396.61.374.971l-.015.135-.822 4.787 4.3-2.26a1.25 1.25 0 0 1 1.024-.062l.14.063 4.3 2.26-.821-4.788a1.25 1.25 0 0 1 .267-1.006l.092-.1 3.478-3.392-4.807-.698a1.25 1.25 0 0 1-.874-.565l-.067-.119-2.15-4.356Z"
			fill={outlineColor}
			fillRule="nonzero"
		/>
		<Path
			d="m9.453 17.229-4.748 2.496a.5.5 0 0 1-.725-.527l.906-5.288a.5.5 0 0 0-.143-.442L.9 9.723a.5.5 0 0 1 .277-.853L6.487 8.1a.5.5 0 0 0 .377-.274l2.374-4.81a.5.5 0 0 1 .896 0l2.375 4.81a.5.5 0 0 0 .376.274l5.31.771a.5.5 0 0 1 .276.853l-3.841 3.745a.5.5 0 0 0-.144.442l.907 5.288a.5.5 0 0 1-.726.527L9.92 17.229a.5.5 0 0 0-.466 0Z"
			fill={starColor}
		/>
		<Path
			d="M8.565 2.683a1.25 1.25 0 0 1 2.242 0l2.316 4.692 5.179.753a1.25 1.25 0 0 1 1.07 1.29l-.013.127a1.25 1.25 0 0 1-.364.715l-3.749 3.653.886 5.158a1.25 1.25 0 0 1-.896 1.416l-.125.027a1.25 1.25 0 0 1-.793-.125l-4.632-2.436-4.632 2.436a1.25 1.25 0 0 1-1.618-.408l-.07-.117a1.25 1.25 0 0 1-.126-.793l.885-5.158L.378 10.26a1.25 1.25 0 0 1-.113-1.665l.09-.102a1.25 1.25 0 0 1 .715-.365l5.178-.753 2.317-4.692ZM9.686 3.8l-2.15 4.356a1.25 1.25 0 0 1-.941.684l-4.808.698 3.48 3.392c.261.255.396.61.374.971l-.015.135-.822 4.787 4.3-2.26a1.25 1.25 0 0 1 1.024-.062l.14.063 4.3 2.26-.821-4.788a1.25 1.25 0 0 1 .267-1.006l.092-.1 3.478-3.392-4.807-.698a1.25 1.25 0 0 1-.874-.565l-.067-.119-2.15-4.356Z"
			fill={outlineColor}
			fillRule="nonzero"
		/>
		<Path
			d="m24.453 23.729-6.511 3.423a.5.5 0 0 1-.726-.527l1.244-7.251a.5.5 0 0 0-.144-.443l-5.268-5.135a.5.5 0 0 1 .277-.853l7.28-1.058a.5.5 0 0 0 .377-.273l3.256-6.597a.5.5 0 0 1 .896 0l3.256 6.597a.5.5 0 0 0 .377.273l7.28 1.058a.5.5 0 0 1 .277.853l-5.268 5.135a.5.5 0 0 0-.144.443l1.244 7.251a.5.5 0 0 1-.725.527l-6.512-3.423a.5.5 0 0 0-.466 0Z"
			fill={starColor}
		/>
		<Path
			d="M23.565 4.683a1.25 1.25 0 0 1 2.242 0l3.197 6.478 7.151 1.04a1.25 1.25 0 0 1 1.07 1.29l-.013.127a1.25 1.25 0 0 1-.364.715l-5.175 5.043 1.222 7.122A1.25 1.25 0 0 1 32 27.914l-.124.028a1.25 1.25 0 0 1-.793-.126l-6.396-3.363-6.395 3.363a1.25 1.25 0 0 1-1.619-.408l-.07-.117a1.25 1.25 0 0 1-.125-.793l1.221-7.122-5.174-5.043a1.25 1.25 0 0 1-.112-1.665l.09-.102a1.25 1.25 0 0 1 .715-.365l7.15-1.04 3.198-6.478ZM24.686 5.8l-3.032 6.143a1.25 1.25 0 0 1-.94.684l-6.78.984 4.906 4.782c.261.256.397.61.375.971l-.016.136-1.158 6.75 6.063-3.186a1.25 1.25 0 0 1 1.024-.063l.14.063 6.062 3.186-1.157-6.75a1.25 1.25 0 0 1 .267-1.006l.093-.1 4.904-4.783-6.778-.984a1.25 1.25 0 0 1-.874-.565l-.067-.12-3.032-6.142Z"
			fill={outlineColor}
			fillRule="nonzero"
		/>
		<Path
			d="M31.686 5.106v-5h-1v5zM28.822 5.212l.97-.242-.12-.485-1-4L28.55 0l-.97.242.121.485 1 4zM33.55 5.212l.121-.485 1-4 .121-.485-.97-.242-.12.485-1 4-.122.485zM17.686 5.106v-5h-1v5zM14.822 5.212l.97-.242-.12-.485-1-4L14.55 0l-.97.242.121.485 1 4zM19.55 5.212l.121-.485 1-4 .121-.485-.97-.242-.12.485-1 4-.122.485z"
			fill={sparkleColor}
			fillRule="nonzero"
		/>
	</Svg>
);
